/*=========================================================================================
  File Name: moduleSparepart.js
  Description: sparepart Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleEquipmentState.js";
import mutations from "./moduleEquipmentMutations.js";
import actions from "./moduleEquipmentActions.js";
import getters from "./moduleEquipmentGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
